// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/snackbar","root":"snackbar-m__root__iX5op"};